import { render, staticRenderFns } from "./APInputModal.vue?vue&type=template&id=08512b33&scoped=true&"
import script from "./APInputModal.vue?vue&type=script&lang=ts&"
export * from "./APInputModal.vue?vue&type=script&lang=ts&"
import style0 from "./APInputModal.vue?vue&type=style&index=0&id=08512b33&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08512b33",
  null
  
)

export default component.exports